import {
  deviceType,
  fraudAndRiskLevel,
  transactionStatus,
  transactionType,
} from "../enums";
import { ITransaction } from "../interfaces-and-types";
import { customersDataHelper } from "./customers-data-helper";

export const transactionsData: ITransaction[] = [
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    amount: 540000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-23493-3233",
    customer: customersDataHelper[0],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-5648cc43-5338cc43-237d0098-1ac3",
    amount: 3640000.55,
    transactionType: transactionType.payment,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2456-5448cc43-5648cc43-237d0098-1ac3",
    amount: 36544000.55,
    transactionType: transactionType.subscription,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5649cc43-5648cc43-237d0098-1ac3",
    amount: 541000.55,
    transactionType: transactionType.payment,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-23493-3233",
    customer: customersDataHelper[4],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-5648cc43-5648cc43-237d0098-1ac3",
    amount: 10000.55,
    transactionType: transactionType.subscription,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.refunded,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "c2456-5648cc43-5648cc43-237d0098-1ac3",
    amount: 360000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5611cc43-5648cc43-237d0098-1ac3",
    amount: 54000.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.refunded,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-2348cc43-5648cc43-237d0098-1ac3",
    amount: 3240000.55,
    transactionType: transactionType.payment,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2456-56481433-5648cc43-237d0098-1ac3",
    amount: 36000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a1426-5648cc43-5648cc43-237d0098-1ac3",
    amount: 1000.55,
    transactionType: transactionType.order,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b3456-5648cc43-5648cc43-237d0098-1ac3",
    amount: 6500.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2456-5612f943-5648cc43-237d0098-1ac3",
    amount: 430000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5648c423-5648cc43-237d0098-1ac3",
    amount: 120000.55,
    transactionType: transactionType.payment,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1a56-5648cc43-5648cc43-237d0098-1ac3",
    amount: 240000.55,
    transactionType: transactionType.payment,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2856-5648cc43-5648cc43-237d0098-1ac3",
    amount: 3000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5648cc32-5648cc43-237d0098-1ac3",
    amount: 5500.55,
    transactionType: transactionType.payment,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.refunded,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-5656cc43-5648cc43-237d0098-1ac3",
    amount: 30000.55,
    transactionType: transactionType.payment,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2456-5648cc43-5634cc43-237d0098-1ac3",
    amount: 365000.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5648ee43-5648cc43-237d0098-1ac3",
    amount: 54030.55,
    transactionType: transactionType.order,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.refunded,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-1768cc43-5648cc43-237d0098-1ac3",
    amount: 60000.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2256-a623cc43-5648cc43-237d0098-1ac3",
    amount: 715000.55,
    transactionType: transactionType.order,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/stripe.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-5655cc43-5648cc43-237d0098-1ac3",
    amount: 13000.55,
    transactionType: transactionType.order,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1477-5648cc43-5648cc43-237d0098-1ac3",
    amount: 40000.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2456-5768cc43-5648cc43-237d0098-1ac3",
    amount: 3500.55,
    transactionType: transactionType.order,
    currency: "USD",
    currencySymbol: "$",
    status: transactionStatus.refunded,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a0456-a548cc43-5648cc43-237d0098-1ac3",
    amount: 560.55,
    transactionType: transactionType.subscription,
    currency: "GBP",
    currencySymbol: "£",
    status: transactionStatus.failed,
    fraudAndRiskLevel: fraudAndRiskLevel.low,
    description: "STA-23493-3233",
    customer: customersDataHelper[1],
    gatewayId: "ee456-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Thur, Jun 13 2022 4:34 AM",
  },
  {
    id: "b1456-5458cc43-5648cc43-237d0098-1ac3",
    amount: 310000.55,
    transactionType: transactionType.subscription,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.medium,
    description: "STA-34493-3233",
    customer: customersDataHelper[2],
    gatewayId: "ee567-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/paystack.svg",
    date: "Wed, Jun 28 2022 3:28 PM",
  },
  {
    id: "d2236-5648cc43-5648cc43-237d0098-1ac3",
    amount: 3240000.55,
    transactionType: transactionType.subscription,
    currency: "NGN",
    currencySymbol: "₦",
    status: transactionStatus.successful,
    fraudAndRiskLevel: fraudAndRiskLevel.high,
    description: "STA-45493-3233",
    customer: customersDataHelper[3],
    gatewayId: "ee789-5648cc43-5648cc43-237d0098-1ac3",
    gatewayLogoUrl: "gateway-logos/flutterwave.svg",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
];
